import { AfterContentInit, Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { TreeSelect } from 'primeng/treeselect';
import { iAdminService } from 'src/app/core/services/iAdmin.service';
import { ServiceTreeUtils } from 'src/app/shared/utils/sercicesTree.utils';
import * as _ from 'underscore';

@Component({
  selector: 'app-create-folder',
  templateUrl: './create-folder.component.html',
  styleUrls: ['./create-folder.component.scss'],
})
export class CreateFolderComponent implements OnInit, AfterContentInit {
  @ViewChild('treeSelectCreateFolder') treeSelect: TreeSelect;
  public form = new FormGroup({
    serviceId: new FormControl(null, Validators.required),
    archive: new FormControl(false),
    description: new FormControl(null, Validators.required),
    classementId: new FormControl(null, Validators.required),
    localisation: new FormControl(null),
    remarques: new FormControl(null),
    accesRestreint: new FormControl(null),
    classementAffine: new FormControl(null),
  });
  serviceParent: any;
  selectedOption: any;
  listCode: any;
  type: 'folder' | 'sleeve';

  constructor(
    public dialogRef: DynamicDialogRef,
    public config: DynamicDialogConfig,
    public iAdminService: iAdminService,
    public toast: ToastrService,
  ) {}

  ngOnInit(): void {
    this.serviceParent = this.config.data.servicesList;
    this.listCode = this.config.data.listCode;
    this.type = this.config.data.type;
  }
  
  ngAfterContentInit() {
    if(this.config.data.code) this.form.patchValue({classementId: this.config.data.code});
    if(this.config.data.serviceId) {
        if(this.config.data.rightAdmin.menu.classementDossiersPartiel) {
          this.serviceParent = this.serviceParent.filter((service) => {
            return this.config.data.userInfos.services.includes(service.id);
          });
        } 
        this.selectedOption = this.serviceParent.filter((x) => x.value === this.config.data.serviceId)[0];
        if(this.config.data.serviceId === this.selectedOption?.value) {
          this.form.patchValue({serviceId: this.config.data.serviceId});
        } else {
          this.selectedOption = null;
          this.form.patchValue({serviceId: null});
        }
    }
  }

  createFolder(type: string) {
    const data = {
      serviceId: this.form.get('serviceId').value,
      archive: this.form.get('archive').value,
      description: this.form.get('description').value,
      classementId: this.form.get('classementId').value,
      localisation: this.form.get('localisation').value,
      remarques: this.form.get('remarques').value,
      classementAffine: this.form.get('classementAffine').value,
      serviceIds: [this.form.get('serviceId').value],
    };
    if(this.type === 'folder') {
      this.iAdminService.createFolder(data).subscribe({
        next: (folder) => {
          this.toast.success('Farde créé avec succès');
          if(type === 'single') {
            const data = {
            folder: folder,
            type: this.type,
            };
            return this.onClose(data);
          } else {
            return this.resetForm();
          }
        },
        error: () => {
          this.toast.error('Erreur lors de la création de la farde');
          return false;
        },
      });
    } else if(this.type === 'sleeve') {
      const dataChemise = {
        ... data,
        fardeId: this.config.data.fardeId,
      };
      this.iAdminService.postChemises(dataChemise).subscribe({
        next: (folder) => {
          this.toast.success('Chemise créé avec succès');
          if(type === 'single') {
            const data = {
              folder: folder,
              type: this.type,
            };
            return this.onClose(data);
          } else {
            return this.resetForm();
          }
        },
        error: () => {
          this.toast.error('Erreur lors de la création de la chemise');
          return false;
        },
      });
    }
  }

  resetForm() {
    this.form.reset();
    this.form.get('archive').setValue(false);
    this.form.get('classementId').setValue(null);
    this.form.get('serviceId').setValue(null);
    this.form.get('localisation').setValue(null);
    this.form.get('remarques').setValue(null);
    this.form.get('classementAffine').setValue(null);
  }

  select(event) {
    ServiceTreeUtils.handleServices(this.iAdminService).subscribe((res) => {
      this.serviceParent = res.serviceParent;
      const servicesParentChild = res.servicesParentChild;
      this.selectedOption = _.first(servicesParentChild.filter((x) => x.value === event.node.value));
      this.form.patchValue({serviceId: event.node.value});
    });
  }

  onClose(folder?) {
    const data = {
      ...folder,
      type: this.type,
      };
    this.dialogRef.close(data);
  }

}
